import React from 'react'
import "../CSS/Template/Blog.css"
import physhing from "../Images/Blog/Thumbnail 1.jpg"
import pyscript from "../Images/Blog/pyscript.jpg"
import nodeJs from "../Images/Blog/node.png"
import dinohack from "../Images/Blog/dino hack.jpg"
import autopy from "../Images/Blog/python autobot.jpg"
import temp from "../Images/Blog/Temperature.jpg"
import mouse from "../Images/Blog/mouse thumnail.jpg"
import Birthday from "../Images/Blog/Birthday.jpg"
import ads from "../Images/Blog/ads-txt.jpg"
import matrix from "../Images/Blog/Matrix Website.jpg"
import Memz from "../Images/Blog/Memz.jpg"
import VMBox from "../Images/Blog/vm.jpg"
import { useHistory } from 'react-router-dom';
import { Helmet } from 'react-helmet'
import FooTer from "./footer"


export default function Blog(props) {
  let history = useHistory()
  return (
    <>
      <Helmet>
        <title>Code Arindam | Blog</title>
      </Helmet>
      <div class="sharethis-sticky-share-buttons" ></div>
      <div id="Yt-blogs">
      <div className="ytb">
          {props.setProgress(0)}
          <img src={VMBox} alt="Loading" />
          <h4>Jul 6, 2022</h4>
          <h2>Full Tutorial Of Virtual Mechine Box(VM Box) </h2>
          <p>How To Start VM Box, Install Of Windows 10, Kali Linux etc</p>
          <h3>Watch The Full blog Click On Below Button</h3>
          <button onClick={() => {
            history.push("/Blog/VM-Box-Tutorial")
          }}>Watch Now</button>
        </div>
        <div className="ytb">
          <img src={Memz} alt="Loading" />
          <h4>Jul 1, 2022</h4>
          <h2>Warning! MEMZ Trojen Windows Demonstration </h2>
          <p>we are installing Memz the dangerous computer virus</p>
          <h3>Watch The Full blog Click On Below Button</h3>
          <button onClick={() => {
            history.push("/Blog/Memz-Virus")
          }}>Watch Now</button>
        </div>
        <div className="ytb">
          {props.setProgress(10)}
          <img src={physhing} alt="Loading" />
          <h4>May 20, 2022</h4>
          <h2>Know More About Physhing actualy what is physhing!</h2>
          <p>In This Blog Show you Guys How Facebook Hack Works? So be awareness from physhing site...</p>
          <h3>Watch The Full blog Click On Below Button</h3>
          <button onClick={() => {
            history.push("/Blog/Phishing")
          }}>Watch Now</button>
        </div>
        <div className="ytb">
          <img src={pyscript} alt="Loading" />
          <h4>May 21, 2022</h4>
          <h2>Know More About pyscript!</h2>
          <p>What is pyscript? How It's Work? Learn All About Pyscript. PyScript Basic...</p>
          <h3>Watch The Full blog Click On Below Button</h3>
          <button onClick={() => {
            history.push("/Blog/Pyscript")
          }}>Watch Now</button>
        </div>
        <div className="ytb">
          <img src={nodeJs} alt="Loading" />
          <h4>May 24, 2022</h4>
          <h2>Create Post Request with Raw HTML Template in NodeJS!</h2>
          <p>How to render HTML Template In NodeJS without using Pug/Ejs Template...</p>
          <h3>Watch The Full blog Click On Below Button</h3>
          <button onClick={() => {
            history.push("/Blog/HTMLrender")
          }}>Watch Now</button>
        </div>
        {props.setProgress(30)}
        <div className="ytb">
          <img src={dinohack} alt="Loading" />
          <h4>May 26, 2022</h4>
          <h2>Fun With Chrome Offline Dino Game!</h2>
          <p>Normal Player Vs Hacker In Chrome offline Dino Game...</p>
          <h3>Watch The Full blog Click On Below Button</h3>
          <button onClick={() => {
            history.push("/Blog/ChromeDinoHack")
          }}>Watch Now</button>
        </div>
        <div className="ytb">
          <img src={autopy} alt="Loading" />
          <h4>May 28, 2022</h4>
          <h2>Send Unlimited Messages With Python!</h2>
          <p>How to send unlimited sms with python module - Pyautogui...</p>
          <h3>Watch The Full blog Click On Below Button</h3>
          <button onClick={() => {
            history.push("/Blog/Python-Unlimited-SMS")
          }}>Watch Now</button>
        </div>
        <div className="ytb">
          <img src={temp} alt="Loading" />
          <h4>Jun 1, 2022</h4>
          <h2>Creating A Responsive Temperature Calculator Website!</h2>
          <p>How I created a temperature Calculator website with HTML,CSS,JS...</p>
          <h3>Watch The Full blog Click On Below Button</h3>
          <button onClick={() => {
            history.push("/Blog/Temperature-Calculate-Website")
          }}>Watch Now</button>
        </div>
        {props.setProgress(50)}
        <div className="ytb">
          <img src={mouse} alt="Loading" />
          <h4>Jun 4, 2022</h4>
          <h2>Disable/Enable Mouse Right Click In Website!</h2>
          <p>How To Disable/Enable mouse right click or create a protected webpage from Hackers...</p>
          <h3>Watch The Full blog Click On Below Button</h3>
          <button onClick={() => {
            history.push("/Blog/Mouse-RightClick-Disable")
          }}>Watch Now</button>
        </div>
        <div className="ytb">
          <img src={Birthday} alt="Loading" />
          <h4>Jun 7, 2022</h4>
          <h2>Created A Responsive Birthday Website!</h2>
          <p>How To Create a responsive Birthday celibratiob website with using HTML,CSS,JS...</p>
          <h3>Watch The Full blog Click On Below Button</h3>
          <button onClick={() => {
            history.push("/Blog/Birthday-Website")
          }}>Watch Now</button>
        </div>
        <div className="ytb">
          <img src={ads} alt="Loading" />
          <h4>Jun 10, 2022</h4>
          <h2>How To add ads.txt file in Google Adsense For Fix Error!</h2>
          <p>How to fixed ads.txt error in Google Adsense...</p>
          <h3>Watch The Full blog Click On Below Button</h3>
          <button onClick={() => {
            history.push("/Blog/Ads-txt-error")
          }}>Watch Now</button>
          {props.setProgress(70)}
        </div>
        <div className="ytb">
          <img src={matrix} alt="Loading" />
          <h4>Jun 18, 2022</h4>
          <h2>Creating A Matrix Screen Website With HTML, CSS, JS!</h2>
          <p>How to created A matrix code running webpage...</p>
          <h3>Watch The Full blog Click On Below Button</h3>
          <button onClick={() => {
            history.push("/Blog/Matrix-Website")
          }}>Watch Now</button>
        </div>
      </div>
      <FooTer />
      {props.setProgress(100)}
    </>
  )
}
